<button
  class="m-btn m-btn--icon"
  type="button"
  [class.m-btn--design]="!!designVariant()"
  [attr.data-variant]="designVariant()"
  [class.m-btn--selected]="selected()"
  [attr.data-selected-tone]="selectedTone()"
  [attr.data-size]="size()"
  [attr.data-icon-only]="designVariant() ? true : null"
  [style.width]="block() ? '100%' : null"
  [disabled]="disabled() || loading()"
  [attr.aria-busy]="loading() || null"
  [attr.aria-label]="ariaLabel()"
  [attr.aria-pressed]="pressed()"
  [attr.aria-expanded]="ariaExpanded()"
  [attr.aria-controls]="ariaControls()"
  [class.m-btn--circle-icon]="style() === 'outline'"
  [class.m-btn--outlined-icon]="style() === 'outlined'"
  [class.m-btn--blank-icon]="style() === 'clear'"
  [class.m-btn--fill-icon]="style() === 'filled'"
  [class.m-btn--subtle-icon]="style() === 'subtle' || style() === 'plain'"
  [class.m-btn--plain-icon]="style() === 'plain'"
  [class.disabled]="disabled() || loading()"
  [class]="`m-btn--${size()} m-btn--${color()}`"
>
  @if (loading()) {
    <span class="m-btn__loader" aria-hidden="true">
      @for (dot of [0, 1, 2]; track dot) {
        <span></span>
      }
    </span>
  } @else {
    <i
      class="aw-2-icn"
      [awIcon]="displayIcon()"
      [style.color]="iconColorValue()"
      [class.m-text-on-color]="iconColor() === 'white'"
      [class]="`aw-2-icn--${iconSize()} ${iconColor() && iconColor() !== 'white' ? 'aw-2-txt--' + iconColor() : ''}`"
    ></i>
  }
</button>
